/* eslint @typescript-eslint/no-explicit-any: 0 */

import React from 'react';

import Tracked from '~/components/Tracked';
import type { MenuItemProps } from '~/legacy/types';
import { logoIcons } from '~/legacy/utils';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import MenuLink from './MenuLink';

export default function ClothingMenuItem({
  link,
  name,
  content,
  pagePosition
}: MenuItemProps) {
  const FeaturedBrands = content?.footwear?.featuredBrands?.children?.map(
    (item: any, i: number) => {
      const { icon, name, viewAll, path } = item;

      return (
        <div key={i} className="size-20">
          <Tracked.ExternalLink
            variant="none"
            pagePosition="Header"
            name={name as TrackedButtonClickName}
            href={`${path}${viewAll?.link || ''}`}
          >
            <img
              alt={name}
              src={logoIcons[icon]}
              loading="lazy"
              className="size-20"
            />
          </Tracked.ExternalLink>
        </div>
      );
    }
  );

  return (
    <li className="main-header__nav__top-list-item">
      <Tracked.ExternalLink
        variant="none"
        pagePosition="Header"
        name={name as TrackedButtonClickName}
        href={link}
        className="main-header__nav__top-list-item--link flex"
      >
        {name}
      </Tracked.ExternalLink>
      {content?.render ? (
        <div className="main-header__nav__sub-nav-list">
          <div className="main-header__nav__sub-nav-list--offset"></div>
          <div className="main-header__nav__sub-nav-list--container">
            <div className="content-width pb-12 pt-8">
              <div>
                <div className="flex flex-row gap-6 pb-6">
                  <div className="text-title-sm">{content?.footwear?.title}</div>
                  {/* Clothing filters */}
                  <div className="flex gap-4">
                    {content?.footwear?.filters.map(
                      (item: MenuItemProps, i: number) => (
                        <MenuLink
                          key={i}
                          title={item?.title}
                          link={item?.link}
                          pagePosition={pagePosition}
                        />
                      )
                    )}
                  </div>
                </div>

                {content?.footwear?.featuredBrands && (
                  <div className="flex flex-col gap-6">
                    <div className="text-title-sm">Featured brands</div>

                    {/* Clothing featured brands */}
                    <div className="grid w-full grid-cols-[repeat(6,auto)] justify-between gap-y-6">
                      {FeaturedBrands}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </li>
  );
}
